import React from 'react';

import ColorConstants from '@shared/constants/ColorConstants';
import DropDownContainer from '@shared/components/layouts/DropDownContainer';
import SwitchButton from '@shared/components/inputs/buttons/SwitchButton';
import { INPUT_PROPS } from './drop-down-with-switch.constants';
import {
    StyledLabel,
    MenuContainer,
    RightMenu,
    ChildrenWrapper,
    StyledTitle,
} from './drop-down-with-switch.styles';

interface IStyles {
    wrapper: React.ComponentType;
    styledTitle: React.ComponentType;
}

interface IDropdowWithSwitch {
    children: React.ComponentType;
    title: string;
    styles?: IStyles;
    isSwitchActive: Boolean;
    onToggleSwitch: Function;
    switchLabel: string;
}

const defaultProps = {
    styles: {},
};

const DropDownWithSwitch = ({
    children,
    title,
    styles,
    isSwitchActive,
    onToggleSwitch,
    switchLabel,
}: IDropdowWithSwitch) => (
    <DropDownContainer styles={styles.wrapper}>
        <MenuContainer>
            <StyledTitle styles={styles.styledTitle}>{title}</StyledTitle>
            <RightMenu>
                <StyledLabel>{switchLabel}</StyledLabel>
                <SwitchButton
                    enabledBackground={ColorConstants.padua}
                    disabledBackground={ColorConstants.salmon}
                    onChange={onToggleSwitch}
                    checked={isSwitchActive}
                    inputProps={{
                        id: INPUT_PROPS.ID,
                    }}
                />
            </RightMenu>
        </MenuContainer>
        <ChildrenWrapper>
            {children}
        </ChildrenWrapper>
    </DropDownContainer>
);

DropDownWithSwitch.defaultProps = defaultProps;

export default DropDownWithSwitch;
